<!--
 * @Author: huhuan@moredian.com
 * @Date: 2023-05-25 15:12:55
 * @LastEditors: 胡奂 huhuan@moredian.com
 * @LastEditTime: 2023-09-05 09:24:40
 * @Description: 
-->
<template>
  <div></div>
</template>
<script>
import { hrefUrl } from 'CONFIG'
import { removeItem, getCode, getQueryString } from '@/utils/comUtils.js'
import { uni } from 'CONFIG'
export default {
  data() {
    return {
      uni,
      memberId: getQueryString('memberId') || null,
      orgId: getQueryString('orgId') || null,
      code: getCode(),
      apiHost: window.location.protocol + '//' + window.location.host
    }
  },
  async mounted() {
    let token = await this.$store.dispatch('checkToken')
    if (this.code && !token.accountId) {
      this.initLogin()
    } else if (this.uni === 'dongfang' && this.memberId && this.orgId && !token.accountId) {
      this.initLogin()
    } else {
      this.$router.push({
        path: '/'
      })
    }
  },
  methods: {
    initLogin() {
      // 删除角色缓存
      removeItem('role')
      // 删除保存在本地的菜单权限
      removeItem('menu')
      // 去除语言类型
      // 删除token
      removeItem('TOKEN')
      this.fetchLoginAuth()
        .then(res => {
          this.$store.commit('setToken', res)
          this.$router.push('/')
        })
        .catch(() => {
          if (process.env.NODE_ENV === 'production') {
            // 报错，跳转登录页面
            setTimeout(() => {
              window.location.href = hrefUrl
            }, 3000)
          }
        })
    },
    // 获取登陆信息
    fetchLoginAuth() {
      if (this.uni === 'dongfang') {
        return this.$httpGet('manageGetUser', {
          orgId: this.orgId,
          memberId: this.memberId
        })
      }
      return this.$httpPost('accountUserLoginAuth', { code: this.code, redirectUri: `${this.apiHost}/hom/uni/#/` })
    }
  }
}
</script>
